'use client';

import { type ButtonHTMLAttributes, forwardRef, type PropsWithChildren } from 'react';
import { cn } from '../_lib/utils';

export type ChipProps = {
	className?: string;
	disabled?: boolean;
};

type ChipTypeProps = ButtonHTMLAttributes<HTMLButtonElement> & ChipProps;

export const Chip = forwardRef<HTMLButtonElement, PropsWithChildren<ChipTypeProps>>(function Chip(props, ref) {
	return (
		<button
			className={cn(
				`text-button-xs py-[0.5625rem] px-[0.75rem] items-center text-brand-secondary bg-purple-10 rounded-[3.25rem] inline-flex justify-center text-left no-underline w-max transition-all duration-normal ease-smooth hover:bg-purple-20 [&>svg]:h-auto`,
				'disabled:bg-black/20 disabled:!text-text-primary disabled:cursor-not-allowed disabled:border-none',
				props.className,
			)}
			disabled={props.disabled}
			ref={ref}
		>
			{props.children}
		</button>
	);
});
